<script>
  import { onMount } from 'svelte'
  import { eventApi } from '../../store'
  let apiEvent
  eventApi.subscribe((value) => {
    apiEvent = value
  })
  let json = []
  ;(function () {
    let xhttp = new XMLHttpRequest()
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        // Typical action to be performed when the document is ready:

        json = JSON.parse(xhttp.responseText)

        console.log(json)
      }
    }
    xhttp.open('GET', `${apiEvent}videos/link.json`, true)
    xhttp.send()
  })()
</script>

<h1 class="text-center mt-5 mb-5">Video Events</h1>

<div class="cards">
  {#if json !== []}
    {#each json as ytvideo}
      <div class="card" style="width: 18rem;">
        <img
          class="card-img-top"
          src="../assets/images/yt.webp"
          alt="Card cap" />
        <div class="card-body">
          <h5 class="card-title">{ytvideo.title}</h5>
          <a target="_blank" href="{ytvideo.link}" class="btn btn-primary">
            Watch
          </a>
        </div>
      </div>
    {/each}
  {/if}
</div>

<style lang="scss">
  .cards {
    width: 80%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    .card {
      margin: auto 20px;
    }
  }
</style>
